/**
 * Architecture view - PROD-644 prototype alignment (Sprint 3.1).
 *
 * Shell wrapper for ArchitectureTab. The tab itself renders the full
 * TLP1 data flow diagram (2-column) + engine status block per the
 * canonical prototype at ai-native-prototype.vercel.app.
 *
 * HC5: zero em / en dashes anywhere.
 * HC6 a11y: section has aria-labelledby; diagram region aria-label in
 *   ArchitectureTab itself.
 *
 * Validation tag: [IMPLEMENTED]
 */
import { ArchitectureTab } from '../components/architecture/ArchitectureTab';

export function Architecture() {
  return (
    <section
      aria-labelledby="view-title-arch"
      data-testid="architecture-view"
      className="px-gutter-lg py-gutter-xl"
    >
      <header className="mb-gutter-xl">
        <h2
          id="view-title-arch"
          className="text-signal-2xl font-semibold text-text-primary"
        >
          Architecture
        </h2>
        <p className="mt-gutter-md max-w-2xl text-signal-base text-text-secondary">
          Cardiometabolic Pathway data flow -- two input streams converge through the Rule Engine,
          Pathway Engine, and LLM Layer to produce NBA cards (clinician) and
          JITAI interventions (patient).
        </p>
      </header>
      <ArchitectureTab />
    </section>
  );
}
